import { render, staticRenderFns } from "./SucessCheck.vue?vue&type=template&id=2fae35f6&scoped=true&"
var script = {}
import style0 from "./SucessCheck.vue?vue&type=style&index=0&id=2fae35f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fae35f6",
  null
  
)

export default component.exports